import { withTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import userLogo from "../../assets/jobSeeker.png";
import routeNames from "../../routes/routeNames";

const JobCard = ({ data }) => {
  const navigate = useNavigate();
  const handleClick = () => {
    navigate(`/jobseeker/profile/${data.key}`);
  };
  return (
    <div
      className="d-flex  p-3 flex-column shadow bg-white  mb-3 jobdet"
      onClick={handleClick}
    >
      <div className="d-flex gap-3 mobss">
        <div className="text-center">
          <img
            src={data?.logo || userLogo}
            width="120px"
            height="120px"
            className="rounded-circle"
            style={{ border: "1px solid rgb(0,0,0,0.2)", padding: "2px" }}
          />
          <h6 className="text-dark mb-0">{data?.title || "NA"}</h6>
          <p
            style={{
              color: "regb(0,0,0,0.4)",
              margin: "0px",
              fontSize: "12px",
            }}
          >
            {data?.role || "NA"}
          </p>
        </div>
        <div className="d-flex flex-column">
          <div className="d-flex loc-s">
            <h6 className="text-info">Skills: </h6>
            <h6 className="skills"> {data?.skills || "NA"} </h6>
          </div>
          <h6 className="text-info mb-0 pb-0">Summary</h6>
          <p className="description mt-0 pt-0">{data?.description || "NA"}</p>
        </div>
      </div>
    </div>
  );
};
export default withTranslation()(JobCard);
